import { gql } from "apollo-boost";

export const GET_REPORT_COMMISSIONS = gql`
query Data($where: ReportCommissionWhereInput!) {
  reportCommission(where: $where) {
    summary {
      totalCount
      totalCommissionValue
    }
    data {
      orderGroupId
      orderGroupCode
      createdAt
      commissionPlatform
      commissionValue
      createdBy {
        id
        firstName
        lastName
        nickname
      }
    }
  }
}
`;